import React, { useEffect, useState, useContext, useRef } from "react";
import "./Landing.scss";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

import ScrollToTop from "../components/ScrollToTop";
import GATracker from "../components/GATracker";
import { LoadingContext } from "../../api/loading/LoadingContext";
import { UserContext } from "../../api/user/userContext";
import LastReplaysSensor from "../replay-app/LastReplaysSensor";

import publishLive from "../../assets/landing/publish-live.gif";
import publishList from "../../assets/landing/publish-list.gif";
import community from "../../assets/landing/community.png";
import i18n from "i18next";
import ReplayHand from "../../api/ReplayHand";
import { Avatars, slug } from "../../api/ReplayVariables";
import xeesterLogo from "../../assets/xeester.png";
import icon from "../../assets/logo.png";
import ReplayPreview from "../components/ReplayPreview";
import AdContainer from "../ads/AdContainer";

function Landing({ location, onShowLogin }) {
  const { user } = useContext(UserContext);
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const [hand, setHand] = useState(null);

  const { t } = useTranslation();

  const scrollbarRef = useRef();
  const _scrollbarRef = React.createRef();

  window.replayerScrolled = (evt) => {
    if (evt.deltaMode === 1) {
      //Firefox->Line mode
      scrollbarRef.current.scrollTop += evt.deltaY * 38;
    } else {
      scrollbarRef.current.scrollTop += evt.deltaY;
    }
    _scrollbarRef.current.updateScroll();
  };

  let subscribeUrl = window.serverUrl+"";
  switch (i18n.language) {
    case "fr": {
      subscribeUrl += "/fr/abonnements";
      break;
    }
    case "en": {
      subscribeUrl += "/en/subscriptions";
      break;
    }
    case "it": {
      subscribeUrl += "/it/abbonamenti";
      break;
    }
    case "pt": {
      subscribeUrl += "/pt/subscriptions-pt";
      break;
    }
    default: {
      break;
    }
  }

  useEffect(() => {
    if ((hand === null && loading.progress === 100) || loading.progress === 0) {
      //console.log("fetching");
      dispatchLoading({ type: "update", payload: 10 });
      let url = window.serverUrl+"/social/landing.php";
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          console.log("data", _data);
          dispatchLoading({ type: "update", payload: 50 });
          if (_data.id) {
            let _hand = ReplayHand.from(_data);
            setHand((h) => _hand);
          }
          setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
          }, 500);
        })
        .catch((err) => {
          dispatchLoading({ type: "update", payload: 100 });
          console.error("fetch problem", err);
        });
      return () => {
        //console.log("replayapp done");
      };
    } else {
      return () => {
        //console.log("replayapp done");
      };
    }
  }, [user, loading.progress, dispatchLoading, hand, setHand]);

  return (
    <>
      <GATracker></GATracker>
      <ScrollToTop></ScrollToTop>
      <PerfectScrollbar
        ref={_scrollbarRef}
        containerRef={(el) => (scrollbarRef.current = el)}
        className="landing-scroll main-scroll"
      >
        <div className="top-login-container">
          {user === null || user.error === 401 ? (
            <>
              <Button className="xeester-logo" href="/" target="_blank">
                <img
                  className="logo img-fluid"
                  src={xeesterLogo}
                  alt="Xeester logo"
                />
                <img className="icon img-fluid" src={icon} alt="Xeester logo" />
              </Button>
              <div className="login-container">
                <div className="d-flex flex-column mr-2 w-50p">
                  <div>{t("replayApp.user.alreadyMember")}</div>
                  <Button className="login" onClick={onShowLogin}>
                    {t("replayApp.user.login")}
                  </Button>
                </div>
                <div className="d-flex flex-column ml-2 w-50p">
                  <div>{t("replayApp.user.notMemberYet")}</div>
                  <Button
                    className="subscribe"
                    href={subscribeUrl}
                    target="_blank"
                  >
                    <div>{t("replayApp.user.signUp")}</div>
                  </Button>
                </div>
              </div>
              <Button
                className="xeester-logo secundary"
                href="/"
                target="_blank"
              >
                <img
                  className="logo img-fluid"
                  src={xeesterLogo}
                  alt="Xeester logo"
                />
                <img className="icon img-fluid" src={icon} alt="Xeester logo" />
              </Button>
            </>
          ) : (
            <>
              <Button className="xeester-logo-logged" href="/" target="_blank">
                <img
                  className="logo img-fluid"
                  src={xeesterLogo}
                  alt="Xeester logo"
                />
                <img className="icon img-fluid" src={icon} alt="Xeester logo" />
              </Button>
              <div className="logged-container">
                <Link
                  to={"/c/" + slug(user.username) + "-" + user.id + "/home"}
                  className="owner-details-container d-flex flex-row"
                >
                  {user.avatar ? (
                    <img
                      className="avatar-image"
                      src={
                        window.serverUrl+"/media/kunena/avatars/" +
                        user.avatar
                      }
                      alt="avatar"
                    />
                  ) : (
                    <img
                      className="avatar"
                      src={
                        Avatars[
                          "avatar" + user.username.substring(0, 1).toUpperCase()
                        ]
                      }
                      alt=""
                    />
                  )}

                  <div className="owner-details d-flex flex-column">
                    <div className="name">{user.username}</div>
                    <div className="subscribers">
                      <NumberFormat
                        value={user.subscribers}
                        displayType={"text"}
                        thousandSeparator={true}
                        renderText={(value) => <>{value}</>}
                      />{" "}
                      {t(
                        user.subscribers > 1
                          ? "replayApp.subscribers"
                          : "replayApp.subscriber"
                      )}
                    </div>
                    <div className="replays">
                      <NumberFormat
                        value={user.replays}
                        displayType={"text"}
                        thousandSeparator={true}
                        renderText={(value) => <>{value}</>}
                      />{" "}
                      {t(
                        user.replays > 1
                          ? "replayApp.user_replays"
                          : "replayApp.user_replay"
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  className="show-replays"
                  to={"/c/" + slug(user.username) + "-" + user.id + "/home"}
                >
                  {t("replayApp.user.showReplays")}
                </Link>
              </div>
            </>
          )}
        </div>
        <div className="landing">
          <div className="landing-container">
            <div className="banner-container">
              <div className="banner details-container">
                <div className="details">
                  <div className="banner-description">
                    <div className="slogan1">
                      {user !== null && user.error !== 401 ? (
                        <>
                          <span className="username">
                            {user.username.charAt(0).toUpperCase() +
                              user.username.substring(1)}
                          </span>
                          ,{" "}
                          {t("landing.h1").charAt(0).toLowerCase() +
                            t("landing.h1").substring(1)}
                        </>
                      ) : (
                        t("landing.h1")
                      )}
                      .
                    </div>
                    <div className="slogan2">{t("landing.h2")}</div>
                    <div
                      className="description"
                      dangerouslySetInnerHTML={{
                        __html: `` + t("landing.description") + ``
                      }}
                    ></div>
                  </div>
                  <img className="img-fluid" src={community} alt="" />
                </div>
              </div>
              <div className="related">
                {user === null || user.error === 401 ? (
                  <div className="login-container">
                    <Button
                      className="xeester-logo"
                      href={window.serverUrl}
                      target="_blank"
                    >
                      <img src={xeesterLogo} alt="Xeester logo" />
                    </Button>
                    <Table>
                      <tbody>
                        <tr>
                          <td>{t("replayApp.user.alreadyMember")}</td>
                          <td>
                            <Button className="login" onClick={onShowLogin}>
                              {t("replayApp.user.login")}
                            </Button>
                          </td>
                        </tr>
                        <tr>
                          <td>{t("replayApp.user.notMemberYet")}</td>
                          <td>
                            <Button
                              className="subscribe"
                              href={subscribeUrl}
                              target="_blank"
                            >
                              {t("replayApp.user.signUp")}
                            </Button>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <Button
                              className="discover"
                              href="/"
                              target="_blank"
                            >
                              {t("replayApp.user.discover")}
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="logged-container">
                    <Button
                      className="xeester-logo"
                      href={window.serverUrl}
                      target="_blank"
                    >
                      <img src={xeesterLogo} alt="Xeester logo" />
                    </Button>
                    <div className="owner-details-container d-flex flex-row">
                      {user.avatar ? (
                        <img
                          className="avatar-image"
                          src={
                            window.serverUrl+"/media/kunena/avatars/" +
                            user.avatar
                          }
                          alt="avatar"
                        />
                      ) : (
                        <img
                          className="avatar"
                          src={
                            Avatars[
                              "avatar" +
                                user.username.substring(0, 1).toUpperCase()
                            ]
                          }
                          alt=""
                        />
                      )}

                      <div className="owner-details d-flex flex-column">
                        <Link
                          to={
                            "/c/" +
                            slug(user.username) +
                            "-" +
                            user.id +
                            "/home"
                          }
                          className="name"
                        >
                          {user.username}
                        </Link>
                        <div className="subscribers">
                          <NumberFormat
                            value={user.subscribers}
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => <>{value}</>}
                          />{" "}
                          {t(
                            user.subscribers > 1
                              ? "replayApp.subscribers"
                              : "replayApp.subscriber"
                          )}
                        </div>
                        <div className="replays">
                          <NumberFormat
                            value={user.replays}
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => <>{value}</>}
                          />{" "}
                          {t(
                            user.replays > 1
                              ? "replayApp.user_replays"
                              : "replayApp.user_replay"
                          )}
                        </div>
                      </div>
                    </div>
                    <Link
                      className="show-replays"
                      to={"/c/" + slug(user.username) + "-" + user.id + "/home"}
                    >
                      {t("replayApp.user.showReplays")}
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className="landing-inner">
              <div className="center-container">
                <div className="details-container">
                  <div className="details">
                    <div className="details-inner">
                      <section>{t("landing.publishLive")}</section>
                      <article
                        dangerouslySetInnerHTML={{
                          __html: `` + t("landing.publishLiveDescription") + ``
                        }}
                      ></article>
                    </div>
                    <img className="img-fluid" src={publishLive} alt="" />
                  </div>
                </div>
                <div className="details-container">
                  <div className="details">
                    <div className="details-inner">
                      <section>{t("landing.share")}</section>
                      <article
                        dangerouslySetInnerHTML={{
                          __html: `` + t("landing.shareDescription") + ``
                        }}
                      ></article>
                    </div>
                    <img className="img-fluid" src={publishList} alt="" />
                  </div>
                </div>
                <div className="details-container featured-hand">
                  <section>{t("landing.featuredHand")}</section>
                </div>
                <div className="replayer-container">
                  {hand !== null &&
                  hand.id !== null &&
                  hand.error !== 401 &&
                  hand.error !== 404 ? (
                    <ReplayPreview hand={hand}></ReplayPreview>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="related">
                <AdContainer location={location}></AdContainer>
                <section>{t("replayApp.related")}</section>
                <div className="replays">
                  <LastReplaysSensor
                    replayId=""
                    page={0}
                    infinite={false}
                  ></LastReplaysSensor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </>
  );
}
export default Landing;
